<template>
  <f-form
      store="@admin/users"
      :id="adminId"
    >
      <template #default="{ item }">
        <div class="is-grid">
          <f-field 
            class="is-col-6"
            label="Prénom"
          >
            <f-input 
              v-model="item.firstname"
              suffix-icon="user"
              :readonly="!canEdit"
            ></f-input>
          </f-field>

          <f-field 
            class="is-col-6"
            label="Nom"
          >
            <f-input 
              v-model="item.lastname"
              suffix-icon="user"
              :readonly="!canEdit"
            ></f-input>
          </f-field>

          <f-field 
            class="is-col-6"
            label="Email"
          >
            <f-input 
              v-model="item.email"
              suffix-icon="envelope-alt"
              :readonly="!canEdit"
            ></f-input>
          </f-field>

          <f-field 
            class="is-col-6"
            label="Rôles"
          >
            <f-select
              v-model="item.roles"
              :options="roles"
              :readonly="!canEdit"
              label="name"
              value="slug"
              long
            ></f-select>
          </f-field>
        </div>

        <div class="is-grid">
          <div class="is-col-12">
            <hr>
          </div>
          
          <f-field 
            class="is-col-6 m-bottom-20"
            label="Partenaire(s)"
          >
            <p 
              v-if="!item.partner_ids || !item.partner_ids.length"
              class="m-bottom-5"
            >
              Pas de partenaire sélectionné
            </p>

            <partner-card-list
              class="m-bottom-5"
              v-for="(partnerId, index) in admin.partner_ids"
              :key="partnerId"
              :id="partnerId"
              @remove="removePartner(item, index)"
              :removable="canEdit"
            ></partner-card-list>
          </f-field>
        </div>

        <select-partner
          v-if="canEdit"
          v-model:partner_ids="item.partner_ids"
        ></select-partner>
      </template>
    </f-form>
</template>

<script>
  import { computed, reactive, toRefs, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'
  import selectPartner from '@components/partners/select-partner'
  import PartnerCard from '@components/partners/view/partner-card'
  import PartnerCardList from '@components/partners/view/partner-card-list'
  import FreebeDesign from '@freebe/design'

  const { useList } = FreebeDesign

  export default {
    setup () {
      const adminId = computed(() => router.currentRoute.value.params.id)
      const { fetchAll: fetchRoles, find: findRoles } = useStore('@admin/roles')
      const { get: getAdmin, patch: patchAdmin } = useStore('@admin/users')
      const { checkPermissions } = useRoles()
      
      const canEdit = computed(() => 
        checkPermissions('users:patch')
      )
            
      fetchRoles()

      const roles = computed(() => findRoles())
      const admin = computed(() => getAdmin(adminId.value))

      const state = reactive({
        store: '@admin/partners',
        query: {
          $sort: {
            updatedAt: -1,
            name: 1,
          }
        },
        search: '',
        fuzzy: {
          keys: ['name']
        },
        loadMore: true,
      }) 

      const list = useList(state)

      function removePartner (item, index) {
        item.partner_ids.splice(index, 1)

        patchAdmin(item._id, {
            partner_ids: item.partner_ids
          }, { local: true })
      }
      
      return {
        ...toRefs(state),
        ...list,
        roles,
        admin,
        adminId,
        canEdit,
        removePartner,
      }
    }, 

    components: {
      selectPartner,
      PartnerCard,
      PartnerCardList,
    } 
  }
</script>